<!--page starts-->
<section class="page-wrapper">
    <div class="shop-cart-top-section cf"> 
        <div class="container">
            <div class="shop-cart-top-detail margin-top-152 cf">
                <div class="titel-box">
					<h2 class="titel-name">SHOPPING CART</h2>
				</div>
                <div class="shop-cart-product-detail">
                    <div class="shop-cart-product-top">
                        <div class="shop-cart-product-top-left">
                            <h3>Products Details</h3>
                        </div>
                        <div class="shop-cart-product-top-center">
                            <h3>Qty.</h3>
                        </div>
                        <div class="shop-cart-product-top-right">
                            <h3>Price</h3>
                        </div>
                    </div>
                    <div class="shop-cart-product-bottom">
                        <div class="shop-cart-product-bottom-detail" *ngFor="let cart of usercartList">
                            <div class="shop-cart-product-bottom-left">
                                <div class="shop-cart-product-bottom-image">
                                    <div class="shop-cart-product-bottom-image-inner">
                                        <img [src]="cart?.image">
                                    </div>
                                </div>
                                <div class="shop-cart-product-bottom-content">
                                    <h2>{{cart?.title}}</h2>
                                    <p *ngIf="cart?.amount">£{{cart?.amount}}.00</p>
                                    <!-- <h4>XMAS-2020-tshirts</h4> -->
                                    <div class="shop-select-size" *ngIf="cart?.size?.length > 0"> 
                                        <div class="custom-select ">
                                            <select id="select_size{{cart?.user_cart_id}}" class="sizechange" (change)="sizeaction(cart?.user_cart_id)">
                                                <option>Select Size</option>
                                                <option value="{{size?.product_size_master_id}}"  *ngFor="let size of cart?.size" class="size" id="{{cart?.user_cart_id}}" [selected]="cart.select_size == size?.size">{{ size?.size}}</option>
                                               
                                            </select>
                                          </div>
                                    </div>
                                </div>
                            </div>
                            <div class="shop-cart-product-bottom-center">
                                <div class="away-fans">
                                    <div  class="select-box">
                                        <div  class="product-quantity">
                                           <div  class="product-quantity-box">
                                              <input  id="quantity{{cart?.user_cart_id}}" name="quantity" readonly="true" type="text" value="{{cart?.quantity}}">
                                              <input id="price{{cart?.user_cart_id}}" name="price" readonly="true" type="hidden" value="{{cart?.amount}}">
                                              <div  class="quantity-selectors-container">
                                                 <div  class="quantity-selectors">
                                                    <button  class="increment-quantity" (click)="incrementquantity(cart?.user_cart_id)" data-direction="1" aria-label="Add one" type="button" id="{{cart?.user_cart_id}}">
                                                        <span>+</span>
                                                    </button>
                                                    <button class="decrement-quantity" (click)="decrementquantity(cart?.user_cart_id)" data-direction="-1" aria-label="Subtract one" type="button" id="{{cart?.user_cart_id}}">
                                                        <span>−</span>
                                                    </button>
                                                 </div>
                                              </div>
                                           </div>
                                        </div>
                                     </div>
                                </div>
                            </div>
                            <div class="shop-cart-product-bottom-right">
                                <div class="shop-cart-product-price">
                                    <h4 *ngIf="cart?.itemTotal" id="pPrice{{cart?.user_cart_id}}"> {{cart?.itemTotal | currency:'&#163;'}}</h4>
                                </div>
                                <div class="shop-cart-product-cross-icon">
                                    <a  (click)="delete_detail(cart?.user_cart_id)"><img src="assets/images/cancel.png"></a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="shop-cart-bottom-section">
        <div class="container">
            <div class="shop-cart-bottom-detail">
               <div class="shop-cart-total-detail">
                   <div class="shop-cart-total-right">
                       <div class="shop-cart-total-box">
                            <div class="shop-cart-subtotal">
                              <h2>Sub Total</h2>
                            </div>
                            <div class="shop-cart-subtotal-center">
                             <input id="subtotal"  readonly="true" type="hidden" value="{{subTotal}}">
                              <h3 id="addsub">{{subTotal | currency:'&#163;'}}</h3>
                            </div>
                            <div class="shop-cart-subtotal-right">
                               <h3 id="shipping">{{shipingcharg | currency:'&#163;'}}</h3>
                            </div>
                        </div>
                        <div class="shop-cart-total-box">
                            <div class="shop-cart-subtotal">
                              <h2>Total Amount</h2>
                            </div>
                            <div class="shop-cart-subtotal-center">
                              <h3 id="addgrand">{{grandTotal | currency:'&#163;'}}</h3>
                            </div>
                            <div class="shop-cart-subtotal-right">
                               <h3></h3>
                            </div>
                        </div>
                   </div>
               </div>
               <div class="shop-cart-checkout-detail">
                   <div class="shop-cart-checkout-left">
                       <a routerLink="/shop"><<>>Back to Shopping</a>
                   </div>

                   <div class="shop-cart-checkout-right" *ngIf="usercartList?.length > 0">
                    <a routerLink="/checkout">Checkout</a>
                       <!-- <button (click)="update_to_cart()">Checkout</button> -->
                   </div>
               </div>
            </div>
        </div>
    </div> 
 </section><!-- page ends-->